module.exports = __webpack_public_path__ + "static/media/icon_website.adde0619.svg";